import React from "react";
import PropTypes from "prop-types";

import { TableBody, TableCell, TableRow } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  titleRoot: {
    marginBottom: 2,
    fontSize: 14,
    letterSpacing: 0.25,
    color: theme?.palette?.common?.dark,
  },
  iconButton: {
    padding: 3,
  },
  ellipsis: {
    display: "block",
    width: "200px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  actionTd: {
    whiteSpace: "nowrap",
  },
  fontBold: {
    fontWeight: 900,
  },
  noDataRow: {
    margin: "0 auto",
  },
}));

const TableItem = ({ rows, columns, scroll, isInvoice, isBill }) => {
  const classes = useStyles();
  let amount = 0;
  let dueAmount = 0;
  let receivedAmount = 0;

  const calculateInvoiceTotal = (row) => {
    amount += row?.amount ?? 0;
    dueAmount += row?.dueAmount ?? row?.pendingAmount;
    receivedAmount += row?.amount - (row?.dueAmount ?? row?.pendingAmount) || 0;
  };
  return (
    <TableBody>
      {!rows?.length ? (
        <TableRow className={classes?.noDataRow}>
          <TableCell colSpan={12} align="center">
            No Data Found
          </TableCell>
        </TableRow>
      ) : (
        <>
          {rows?.length &&
            rows.map((data, index) => {
              if (isInvoice) calculateInvoiceTotal(data);
              if (isBill) calculateInvoiceTotal(data);

              return (
                <TableRow
                  hover
                  tabIndex={-1}
                  key={data.name}
                  sx={{ cursor: "pointer" }}
                >
                  {columns?.length &&
                    columns.map((cell, i) => (
                      <React.Fragment key={i}>
                        {!cell?.hide && (
                          <TableCell key={i}>
                            {cell?.image ? (
                              <></>
                            ) : (
                              <div
                                className={
                                  cell.ellipsis
                                    ? classes.ellipsis
                                    : scroll
                                    ? classes.actionTd
                                    : ""
                                }
                              >
                                {cell.render
                                  ? cell.render(data, index)
                                  : data[cell?.id]}
                              </div>
                            )}
                          </TableCell>
                        )}
                      </React.Fragment>
                    ))}
                </TableRow>
              );
            })}
          {(isInvoice || isBill) && (
            <>
              <TableRow hover tabIndex={-1} sx={{ cursor: "pointer" }}>
                <TableCell colSpan={3} sx={{ fontWeight: 600 }}>
                  TOTAL
                </TableCell>
                <TableCell sx={{ fontWeight: 600 }}>{amount}</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>{receivedAmount}</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>{dueAmount}</TableCell>
                <TableCell />
              </TableRow>
            </>
          )}
        </>
      )}
    </TableBody>
  );
};

TableItem.propTypes = {
  rows: PropTypes.array,
  columns: PropTypes.array,
  scroll: PropTypes.bool,
};

TableItem.defaultProps = {
  scroll: false,
};

export default TableItem;
